import { render } from "./PasswordSelectView.vue?vue&type=template&id=5f97b3f8"
import script from "./PasswordSelectView.vue?vue&type=script&lang=js"
export * from "./PasswordSelectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__